const projectReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default projectReducer;